import EmptyStateOverlay from 'components/base/empty-states/EmptyStateOverlay/EmptyStateOverlay';
import useEmptyStateConfig from './useEmptyStateConfig';
import EmptyStateBackground from './images/empty-state-background.svg';
import styled from 'styled-components';
import { StyledEmptyStateOverlay } from 'components/base/empty-states/EmptyStateOverlay/EmptyStateOverlay.style';

const StyledEmptyState = styled.div`
  & ${StyledEmptyStateOverlay} {
    background-size: 90% 90%;
  }
`;

const EmptyState = ({ type }) => {
  const { Illustration, Title, Description, Actions } = useEmptyStateConfig({
    type
  });

  return (
    <StyledEmptyState>
      <EmptyStateOverlay
        Background={EmptyStateBackground}
        Illustration={Illustration}
        Title={Title}
        Description={Description}
        Actions={Actions}
      />
    </StyledEmptyState>
  );
};

export default EmptyState;
